import React from "react";
import "./ShippingUI.css";

const BOXES = [
  { label: "Box (6x6x6)", length: 6, width: 6, height: 6 },
  { label: "Box (10x6x4)", length: 10, width: 6, height: 4 },
  { label: "Box (12x4x4)", length: 12, width: 4, height: 4 },
  { label: "Box (12x6x4)", length: 12, width: 6, height: 4 },
  { label: "Box (12x8x8)", length: 12, width: 8, height: 8 },
  { label: "Box (12x9x4)", length: 12, width: 9, height: 4 },
  { label: "Box (12x12x8)", length: 12, width: 12, height: 8 },
  { label: "Box (16x8x6)", length: 16, width: 8, height: 6 },
  { label: "Box (16x10x6)", length: 16, width: 10, height: 6 },
  { label: "Box (20x14x6)", length: 20, width: 14, height: 6 },
];

interface BoxSizeSelectProps {
  setPackageDimensions: React.Dispatch<
    React.SetStateAction<{
      length: number;
      width: number;
      height: number;
      weight: number;
    }>
  >;
}

export const BoxSizeSelect: React.FC<BoxSizeSelectProps> = ({
  setPackageDimensions,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const box = BOXES[parseInt(e.target.value)];
    if (box) {
      setPackageDimensions((prev) => ({
        ...prev,
        length: box.length,
        width: box.width,
        height: box.height,
      }));
    }
  };

  return (
    <label>
      Select Box Size:
      <select
        className="shipping-ui-select"
        onChange={handleChange}
        defaultValue=""
      >
        <option value="" disabled>
          Select a box
        </option>
        {BOXES.map((box, index) => (
          <option key={index} value={index}>
            {box.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default BoxSizeSelect;
